import { render, staticRenderFns } from "./VideoTable.vue?vue&type=template&id=75c42e13&scoped=true"
import script from "./VideoTable.vue?vue&type=script&lang=js"
export * from "./VideoTable.vue?vue&type=script&lang=js"
import style0 from "./VideoTable.vue?vue&type=style&index=0&id=75c42e13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c42e13",
  null
  
)

export default component.exports